import { SET_ERROR, SET_LOADING, SET_LOAN_PAYMENT_DETAILS } from './types';
import * as types from '../processStep/types';
import debounce from 'lodash.debounce';

const state = {
  error: false,
  loading: false,
  loanPaymentDetails: [],
};

const actionBuilder = (client) => {
  const calculateLoanPaymentDetails = (store, data = []) => {
    store.commit(SET_ERROR, false);
    store.commit(SET_LOADING, true);

    const _calculateLoanDetails = body => {
      if (Object.values(body).some(value => !value && typeof value !== 'number')) {
        return Promise.reject(`Unexpected value found in ${Object.values(body)}. Values have to be provided.`);
      }

      return client.calculateLoanDetails(body);
    };

    data = Array.isArray(data) ? data : [data];

    return Promise.all(data.map(body => _calculateLoanDetails(body)))
      .then(response => response.map(({ data }) => data))
      .then(data => store.commit(SET_LOAN_PAYMENT_DETAILS, data))
      .catch(() => {
        store.commit(SET_ERROR, true);
        store.commit(SET_LOAN_PAYMENT_DETAILS, []);
      })
      .finally(() => store.commit(SET_LOADING, false));
  };

  // Calculation seems to take over 100 ms, even 400 ms
  // Block using slider too much which would overwhelm BBO
  const debouncedCalculateLoanPaymentDetails = debounce(calculateLoanPaymentDetails, 100);

  return {
    calculateLoanPaymentDetails,
    debouncedCalculateLoanPaymentDetails,
  };
};

const mutations = {
  [SET_ERROR]: (state, error) => {
    state.error = error;
  },
  [SET_LOADING]: (state, loading) => {
    state.loading = loading;
  },
  [SET_LOAN_PAYMENT_DETAILS]: (state, loanPaymentDetails) => {
    state.loanPaymentDetails = loanPaymentDetails;
  },
};

const getters = {
  loanError: state => state.error,
  loanLoading: state => state.loading,
  loanPaymentDetails: state => state.loanPaymentDetails,
};

const moduleBuilder = (client) => {
  return {
    namespaced: true,
    state,
    actions: actionBuilder(client),
    getters,
    mutations,
  };
};

export default {
  moduleBuilder,
  types,
};
